import { render, staticRenderFns } from "./LvText.vue?vue&type=template&id=51950410"
import script from "./LvText.vue?vue&type=script&lang=js"
export * from "./LvText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports